import Header from "../components/Header";

import { useNavigate } from 'react-router-dom';

export default function Recepcao() {

  const navigate = useNavigate()

  function enviar (){
    navigate("/")
  }
    return (
      <>
      <Header />
      <div className="min-h-screen  flex flex-col items-center justify-center">
        
        {/* Símbolo de sucesso (V verde) */}
        <div className="w-24 h-24 bg-green-500 rounded-full flex items-center justify-center mb-8">
          <svg
            className="w-16 h-16 text-white"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>
  
        {/* Mensagem de sucesso */}
        <h1 className="text-3xl md:text-4xl font-bold text-center mb-4" style={{ color: '#eb9605' }}>
          Formulário Recebido!
        </h1>
        <p className="text-lg text-gray-600 text-center max-w-lg mx-auto">
          Obrigado por enviar suas informações. Em breve retornaremos com a sua cotação.
        </p>
        <div className="flex justify-center mt-6 w-full max-w-[500px]">
            <button
              onClick={enviar}
              className="w-full max-w-[100px] mx-auto bg-[#f94b1b] text-white py-2 px-4 rounded-md shadow-sm hover:bg-[#d18a05]"
            >
              Voltar
            </button>
        </div>
      </div>
      </>
    );
  }